module.exports = __webpack_public_path__ + "static/media/lol_logo_white.f4c835fc.png";